import { PromoTermRateDto } from '@src/data/api/merchants-api/merchants-api'

// Applies the merchant's Custom Buydown rate rebate to the base (no-rebate) per-term rates for
// display. Mirrors the backend BuyDownRateCalculator, which subtracts the rebate from the annual
// rate and floors it at 0. The rebate is never frozen onto the plan — its single source of truth
// is Merchant.FlashPlanRateRebate — so it is applied here at display time.
export const applyRebateToTermRates = (rates: PromoTermRateDto[], rebate: number): PromoTermRateDto[] =>
  rates.map((rate) => ({
    ...rate,
    promoRate: Math.max(0, rate.promoRate - rebate),
    regularRate: Math.max(0, rate.regularRate - rebate),
  }))
